import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "dark" | "soft" | "accentPill" | "danger" | "ghost";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * primary：黄色主按钮（底部深黄色阴影边）；dark：深色胶囊；soft：浅色胶囊；
   * accentPill：黄色小胶囊（"开始""布置""兑换"）；danger：红色文字的浅色胶囊；ghost：无底色
   */
  variant?: ButtonVariant;
  /** 高度（px），默认 primary 56、其它 48 */
  height?: number;
  /** 占满一行 */
  block?: boolean;
  /** 进行中：显示转圈并禁用 */
  busy?: boolean;
  icon?: ReactNode;
}

export function Button({ variant = "primary", height, block, busy, icon, className, children, disabled, style, type = "button", ...rest }: ButtonProps) {
  const h = height ?? (variant === "primary" ? 56 : 48);
  const cls = ["kp-btn", `kp-btn--${variant}`, block ? "kp-btn--block" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <button type={type} className={cls} disabled={disabled || busy} style={{ minHeight: h, borderRadius: h / 2, ...style }} {...rest}>
      {busy ? <Spinner /> : icon}
      {children != null && <span>{children}</span>}
    </button>
  );
}

/** 转圈 */
export function Spinner({ size = 18 }: { size?: number }) {
  return <span className="kp-spinner" style={{ width: size, height: size }} aria-label="加载中" />;
}

/** 圆形图标按钮（返回、关闭等） */
export function IconButton({ label, children, size = 40, className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { label: string; size?: number }) {
  return (
    <button type="button" aria-label={label} title={label} className={`kp-icon-btn ${className ?? ""}`} style={{ width: size, height: size }} {...rest}>
      {children}
    </button>
  );
}
